import { useCallback, useEffect, useRef } from 'react';
var popupCloseHandlers = new Set();
export var usePopupClose = function (closeFn) {
    var closeFnRef = useRef(closeFn);
    closeFnRef.current = closeFn;
    useEffect(function () {
        popupCloseHandlers.add(closeFnRef.current);
        return function () {
            popupCloseHandlers.delete(closeFnRef.current);
        };
    }, []);
    var triggerClose = useCallback(function () {
        closeFnRef.current();
    }, []);
    return {
        triggerClose: triggerClose,
    };
};
export var closeAllPopups = function () {
    popupCloseHandlers.forEach(function (fn) { return fn(); });
};
